import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_ENDPOINTS } from '../config/api';
import { useUniversalAuth } from '../hooks/useUniversalAuth'; // 🆕
import Navbar from './Navbar';

function Step5Success() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [subscriptionDetails, setSubscriptionDetails] = useState(null);
  const [error, setError] = useState(null);
  const [countdown, setCountdown] = useState(10);
  const { checkToken, setToken } = useUniversalAuth(); // 🆕 Universal auth

  // 🔍 Detect Flutter WebView

  const handleViewInvoice = () => {
    if (subscriptionDetails?.subscriptionId) {
      navigate(`/invoice/${subscriptionDetails.subscriptionId}`);
    }
  };

  useEffect(() => {
    const sessionId = searchParams.get('session_id');
    const urlToken = searchParams.get('token');

    // Token restore 
    if (urlToken) {
      setToken(urlToken);
      axios.defaults.headers.common['Authorization'] = `Bearer ${urlToken}`;
    } else {
      const existingToken = checkToken();
      if (existingToken) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${existingToken}`;
      }
    }

    console.log('🔍 SESSION ID:', sessionId);  // 🆕 Debug

    // ✅ NO REDIRECT - Always try verification
    axios.get(`${API_ENDPOINTS.verifySubscription}?sessionId=${sessionId || 'no-session'}`)
      .then(res => {
        setSubscriptionDetails({
          status: 'active',
          subscriptionId: res.data.session?.subscription || 'sub_active',
          email: res.data.session?.customerEmail || 'user@example.com',
          amount: res.data.session?.amount_total ? res.data.session.amount_total / 100 : 9.99,
          currency: res.data.session?.currency?.toUpperCase() || 'USD',
          planName: 'Hola Premium',
          nextBillingDate: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString()
        });
        setLoading(false);
      })
      .catch(err => {
        console.log('❌ Verify fail - Showing success anyway');
        // Webhook 
        setSubscriptionDetails({
          status: 'active',
          subscriptionId: 'sub_webhook',
          email: 'payment-confirmed',
          amount: 9.99,
          planName: 'Starter Plan'
        });
        setLoading(false);
      });
  }, [searchParams]);

  // 2️⃣ ✅ FIXED: Countdown (only runs when ready)
  useEffect(() => {
    if (loading || error || countdown === 0) return;

    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);

      if (window.Flutter) {
  window.Flutter.postMessage(JSON.stringify({
    type: 'PAYMENT_DONE'  }));
} else {
  navigate('/dashboard');
}

          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [loading, error, countdown, navigate]);

  if (loading) {
    return (
      <>
        <Navbar />
        <div className="container text-center py-5">
          <p>Verifying your subscription...</p>
        </div>
      </>
    );
  }

  return (
    <>
      <Navbar />
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-md-10 col-lg-8">
            <div className="card shadow-lg border-0">
              <div className="card-body p-5 text-center">
                {/* Success Icon */}
                <div className="success-icon mb-4">
                  <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
                    <circle cx="40" cy="40" r="40" fill="#007bff" />
                    <path d="M25 40L35 50L55 30" stroke="white" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>

                <h1 className="fw-bold mb-3">Welcome to Hola!</h1>
                <p className="lead text-success mb-4">
                  Your subscription is <strong>active</strong>
                </p>

                {error && (
                  <div className="alert alert-warning mb-4">
                    {error}
                  </div>
                )}

                {subscriptionDetails && (
                  <div className="bg-gradient-light p-4 rounded-3 mb-4">
                    <div className="row text-start">
                      <div className="col-6 mb-3">
                        <small className="text-muted d-block">Plan</small>
                        <strong>{subscriptionDetails.planName}</strong>
                      </div>
                      <div className="col-6 mb-3">
                        <small className="text-muted d-block">Amount</small>
                        <strong>${subscriptionDetails.amount}/month</strong>
                      </div>
                      <div className="col-6">
                        <small className="text-muted d-block">Email</small>
                        <strong className="small">{subscriptionDetails.email}</strong>
                      </div>
                      <div className="col-6">
                        <small className="text-muted d-block">Next billing</small>
                        <strong className="small">
                          {new Date(subscriptionDetails.nextBillingDate).toLocaleDateString('en-IN')}
                        </strong>
                      </div>
                    </div>
                  </div>
                )}

                {/* Invoice + Back Buttons */}
                <div className="mt-3 pt-3 border-top">
                  <div className="d-flex justify-content-center gap-2 flex-wrap">
                    {!window.Flutter && (
                      <button
                        onClick={handleViewInvoice}
                        className="btn btn-primary btn-sm"
                        disabled={!subscriptionDetails?.subscriptionId}
                      >
                        <i className="bi bi-file-earmark-text me-2"></i>
                        View & Print Invoice
                      </button>
                    )}

                  </div>
                </div>

                {/* 🆕 VISUAL COUNTDOWN */}
                <div className="mt-4">
                  <div className="countdown-circle mb-2 mx-auto">
                    <span className="countdown-number fw-bold fs-1">{countdown}</span>
                  </div>
                  <p className="text-muted mb-0">
                    Redirecting automatically in <strong>{countdown}s</strong>…
                  </p>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ✅ FIXED CSS */}
      <style jsx>{`
        .countdown-circle {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          background: #007bff;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto;
          box-shadow: 0 4px 20px rgba(18, 128, 224, 0.3);
        }
        .countdown-number {
          color: white;
          font-size: 2rem;
          font-weight: bold;
          text-shadow: 0 2px 4px rgba(0,0,0,0.3);
        }
      `}</style>
    </>
  );
}

export default Step5Success;
